export class searchBitaMovFilters {
    public bin: string;    
    public fechaInicio: string;
	public fechaFin: string;
	public paginaActual: number;
	public pdf: boolean;
		
		constructor() {			
			this.fechaInicio = null;
			this.fechaFin = null;
			this.bin = null;
			this.paginaActual = 1;
			this.pdf = false;
		}
  }

  